import { render, staticRenderFns } from "./PublicationsFilter.vue?vue&type=template&id=60738d73&"
import script from "./PublicationsFilter.vue?vue&type=script&lang=js&"
export * from "./PublicationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports